import { createContext, useContext, useState } from "react";
import { v4 as createGuid } from 'uuid';

const AuditScopeContext = createContext<string | null>(null);
const AuditScopeConsumer = AuditScopeContext.Consumer;

type AuditScopeProps = {
    children?: React.ReactNode;
}

const AuditScope: React.FC<AuditScopeProps> = (props) => {
    const { children } = props;
    const [ value, _setValue ] = useState<string>(createGuid());

    return (
        <AuditScopeContext.Provider value={value}>
            {children}
        </AuditScopeContext.Provider>
    );
};

const useAuditScope = () => useContext(AuditScopeContext);

export default AuditScope;
export { useAuditScope, AuditScopeConsumer };